import React, { useEffect, useState } from "react"
import axios from "axios"
import { Link, useHistory, useParams } from "react-router-dom"
import "../style.css"
import { Alert, Button, Glyphicon, Checkbox, ControlLabel, FormControl, FormGroup } from "react-bootstrap"
import getServerURL from "../../../../functions/getServerURL"
import LoadingAnimation from "../../../../reuseable-components/LoadingAnimation"
import Question from "./Question"
import { ALL_OF_THE_ABOVE } from "../../QMSTrainingManager/TrainingContainer/EditAssessmentModal"
import QMSHelpFooter from "../QMSHelpFooter"


export default function Assessment(props) {
  // REACT ROUTER DOM
  const params = useParams()
  const history = useHistory()
  const qmsRoute = props.qmsRoute
  const context = props.context

  // STATE
  const [redirect, setRedirect] = useState(false)
  const [assessment, setAssessment] = useState(null)
  const [loadingAssessment, setLoadingAssessment] = useState(false)
  const [assessmentSubmitted, setAssessmentSubmitted] = useState(false)
  const [submittingAssessment, setSubmittingAssessment] = useState(false)
  const [selectedAnswers, setSelectedAnswers] = useState({})
  const [message, setMessage] = useState(null)
  const [wrongAnswers, setWrongAnswers] = useState({})
  const [missedQuestions, setMissedQuestions] = useState({})
  const [assessmentResults, setAssessmentResults] = useState(null)
  const [complianceChecks, setComplianceChecks] = useState({
    confirmRead: false,
    confirmComply: false,
    confirmESignature: false,
  })
  const [eSignature, setESignature] = useState("")

  const shuffle = (array) => {
    let currentIndex = array.length,  randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--

      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }

    return array
  }

  const getAssessment = () => {
    setLoadingAssessment(true)
    setMessage(null)

    if (context === "assessment") {

      axios.get(`${ getServerURL() }trainings/${params.id}/get_assigned_assessment/`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        if (response.data.message) {
          setMessage({
            text: response.data.message.text,
            status: response.data.message.status,
          })
          setAssessment(response.data.assessment)
        } else {
          let assessment = response.data
          let answers = {}
          assessment.questions = shuffle(assessment.questions)
          assessment.questions = assessment.questions.map(question => {
            answers[question.id] = []
            return {
              ...question,
              options: shuffle(question.options)
            }
          })
          // PUTTING THE "All of the above" OPTION TO THE END OF THE LIST OF OPTIONS
          // AND SORTING THE BOOLEAN OPTIONS SO THAT "True" APPEARS FIRST
          assessment.questions.forEach(question => {
            if (question.type === "Radio"){
              let aboveAll = null
              question.options.forEach((option, index) => {
                if (option.name === ALL_OF_THE_ABOVE) aboveAll = question.options.splice(index, 1)[0]
              })
              if (aboveAll) question.options.push(aboveAll)
            } else if (question.type === "Boolean") {
              question.options.sort((a, b) => b.name.localeCompare(a.name))
            }
          })
          setAssessment(assessment)
          setSelectedAnswers(answers)
        }
      }).catch(error => {
        if (error.response.status === 404) {
          setRedirect(true)
        }
      }).finally(() => {
        setLoadingAssessment(false)
      })

    } else if (context === "preview") {

      axios.get(`${ getServerURL() }assessments/${params.assessmentId}/get_assessment_manager_details/`, {
        headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
      }).then(response => {
        console.log(response)
        let assessment = response.data
        let answers = {}
        assessment.questions = shuffle(assessment.questions)
        assessment.questions = assessment.questions.map(question => {
          answers[question.id] = []
          return {
            ...question,
            options: shuffle(question.options)
          }
        })
        // PUTTING THE "All of the above" OPTION TO THE END OF THE LIST OF OPTIONS
        // AND SORTING THE BOOLEAN OPTIONS SO THAT "True" APPEARS FIRST
        assessment.questions.forEach(question => {
          if (question.type === "Radio"){
            let aboveAll = null
            question.options.forEach((option, index) => {
              if (option.name === ALL_OF_THE_ABOVE) aboveAll = question.options.splice(index, 1)[0]
            })
            if (aboveAll) question.options.push(aboveAll)
          } else if (question.type === "Boolean") {
            question.options.sort((a, b) => b.name.localeCompare(a.name))
          }
        })
        setAssessment(assessment)
        setSelectedAnswers(answers)
      }).catch(error => {
        if (error.response.status === 404) {
          setRedirect(true)
        }
      }).finally(() => {
        setLoadingAssessment(false)
      })

    }
  }

  const selectAnswer = (question, answer) => {
    if (question.type === "Multiselect") {
      if (selectedAnswers[question.id]) {
        if (selectedAnswers[question.id].includes(answer)) {
          let filteredAnswers = selectedAnswers[question.id].filter(ans => ans !== answer)
          setSelectedAnswers({ ...selectedAnswers, [question.id]: filteredAnswers })
        } else {
          setSelectedAnswers({ ...selectedAnswers, [question.id]: [...selectedAnswers[question.id], answer] })
        }
      } else {
        setSelectedAnswers({ ...selectedAnswers, [question.id]: [answer] })
      }
    } else {
      setSelectedAnswers({ ...selectedAnswers, [question.id]: [answer] })
    }
  }

  const submitAssessment = () => {
    const tempMissedQuestions = {}
    for (const questionID of Object.keys(selectedAnswers)) {
      if (!selectedAnswers[questionID].length) {
        tempMissedQuestions[questionID] = true
      }
    }

    setMissedQuestions(tempMissedQuestions)

    if (Object.keys(tempMissedQuestions).length) {
      return
    }

    setSubmittingAssessment(true)
    const postObject = {
      assessment: assessment.id,
      answers: selectedAnswers
    }

    axios.post(`${getServerURL()}assessments/submit_assessment/`, postObject, {
      headers: { "Authorization": `Bearer ${ localStorage.getItem("token") }` }
    }).then(response => {
      setAssessmentSubmitted(true)
      setWrongAnswers(response.data.wrong_answers)
      setAssessmentResults(response.data)
    }).catch(error => {
      console.log(error.response)
    }).finally(() => setSubmittingAssessment(false))
  }

  useEffect(() => {
    getAssessment()
  }, [])

  useEffect(() => {
    if (redirect) {
      if (context === "assessment") {
        history.replace(`${qmsRoute}${params.id}`)
      } else if (context === "preview") {
        history.replace(`${qmsRoute}`)
      }
    }
  }, [redirect])

  const validateNameEntry = () => {
    if (eSignature.length > 3) return "success"
    return null
  }

  const validateComplianceChecks = () => {
    const { confirmRead, confirmComply, confirmESignature } = complianceChecks

    if (confirmRead && confirmComply && confirmESignature && (eSignature.length > 3)) {
      return false
    } else {
      return true
    }
  }

  const renderAssessmentResultsMessage = () => {
    if (assessmentSubmitted && assessmentResults) {
      if (assessmentResults.status === "Passed") {
        return (
          <Alert bsStyle="success">
            Congratulations, you have successfully passed the assessment. <br/>
            You can preview and download your certificate <a target="_blank" href={assessmentResults.result.certificate}>here</a>.
          </Alert>
        )
      } else if (assessmentResults.status === "Failed") {
        return (
          <Alert bsStyle="danger" style={{ paddingBottom: "50px" }}>
            You have failed the assessment. In order to retake it please click on the retake button. <br/>
            <Button
              onClick={ () => window.location.reload() }
              style={{ float: "right" }}
            >
              Retake
            </Button>
          </Alert>
        )
      } else {
        return null
      }
    } else {
      return (
        <Alert bsStyle="info" style={{ paddingBottom: "50px" }}>
          <div>
            <label style={{ cursor: "pointer" }}>
              <Checkbox disabled={!!(context === "preview")} onChange={() => setComplianceChecks({...complianceChecks, confirmRead: !complianceChecks.confirmRead})} checked={complianceChecks.confirmRead}>
                <strong>
                  I confirm that I have read and understood '{assessment.name.split(" ")[0]}'.
                </strong>
              </Checkbox>
            </label>
            <br />
            <label style={{ cursor: "pointer" }}>
              <Checkbox disabled={!!(context === "preview")} onChange={() => setComplianceChecks({...complianceChecks, confirmComply: !complianceChecks.confirmComply})} checked={complianceChecks.confirmComply}>
                <strong>
                  I confirm that I will comply with '{assessment.name.split(" ")[0]}'.
                </strong>
              </Checkbox>
            </label>
            <br />
            <label style={{ cursor: "pointer" }}>
              <Checkbox disabled={!!(context === "preview")} onChange={() => setComplianceChecks({...complianceChecks, confirmESignature: !complianceChecks.confirmESignature})} checked={complianceChecks.confirmESignature}>
                <strong>
                  By checking this box, I consent to use electronic signature to digitally sign and date the
                  "Genesis Research Individual Training and Knowledge Assessment Record".
                </strong>
              </Checkbox>
            </label>
            {complianceChecks.confirmESignature ?
                <div style={{width: "90%", margin: "auto"}}>
                  <FormGroup validationState={validateNameEntry()}>
                    <ControlLabel>Please enter your full name to confirm eSignature:</ControlLabel>
                    <FormControl 
                      type="text"
                      value={eSignature}
                      onChange={(e) => setESignature(e.target.value)}
                      disabled={!!(context === "preview")}
                    />
                    <FormControl.Feedback/>
                    <br/>
                  </FormGroup>
                </div>
              :
                null
            }
              {Object.keys(missedQuestions).length ?
                <Alert bsStyle="warning">
                  <strong>Warning</strong>: Please answer all of the questions in the assessment before submitting. <br /><br />
                  You missed <strong>{Object.keys(missedQuestions).length}</strong> question(s).
                </Alert>
                :
                null
              }
            <Button
              onClick={ submitAssessment }
              style={{ float: "right" }}
              disabled={ submittingAssessment || validateComplianceChecks() || !!(context === "preview") }
            >
              Submit{ submittingAssessment ? "ting" : null }
            </Button>
          </div>
        </Alert>
      )
    }
  }

  const renderAssessment = () => {
    if (assessment) {
      return (
        <div>
          <div style={{ float:"left", position: "absolute" }}>
            <Link to={ context === "assessment" ? `${qmsRoute}${params.id}` : `${qmsRoute}` }>
              <Button className="back-button">
                <Glyphicon glyph="arrow-left" /> Back
              </Button>
            </Link>
          </div>
          <br/>
          <center>
            <h3>
              { assessment.name }
            </h3>
          </center>
          <br/>
          { message ?
            <Alert bsStyle={ message.status }>{ message.text }</Alert>
            :
            <React.Fragment>
              <ol className="required-score">
                { Math.ceil(assessment.questions.length / 100 * assessment.required_score) } out of { assessment.questions.length } questions need to be answered correctly in order to pass.
              </ol>
              <ol>
                { assessment.questions.map(question => {
                  return (
                    <Question
                      key={ question.id }
                      question={ question }
                      selectedAnswer={ selectedAnswers[question.id] }
                      selectAnswer={ selectAnswer }
                      assessmentSubmitted={ assessmentSubmitted }
                      submittingAssessment={ submittingAssessment }
                      wrongAnswers={ wrongAnswers[question.id] || null }
                      missedQuestion={ missedQuestions[question.id] || null }
                    />
                  )
                }) }
              </ol>
            {
              !assessmentSubmitted ? null :
              <div className="legends">
                <div style={{ width: "10px", height: "10px", backgroundColor: "red", display: "inline-block", marginRight: "10px"}}></div>
                <span className="legend-error">Incorrect answers</span>
                <span className="legend-success">
                <div style={{ width: "10px", height: "10px", backgroundColor: "blue", display: "inline-block", marginRight: "10px"}}></div>
                Correct answers
                </span>
              </div>
            }
              <div style={{ marginBottom: "20%" }}>
                { renderAssessmentResultsMessage() }
              </div>
            </React.Fragment>
          }
        </div>
      )
    } else {
      return (
        <div>Assessment for this training does not exist.</div>
      )
    }
  }

  return (
    <div>
      <div id="Assessment">
        { context === "preview" ?
            <p className="assessment-preview-watermark">Manager Preview</p>
            :
            null
        }
        { loadingAssessment ?
          <LoadingAnimation />
          :
          <div className={ submittingAssessment ? "transparent" : null }>
            { renderAssessment() }
          </div>
        }
      </div>
      <br />
      <br />
      <br />
      <QMSHelpFooter/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Assessment/index.js